import React, { useState, useContext, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Layout from '../Components/Layout/Layout';
import { AuthContext } from '../contextStore/AuthContext';
import { getProductRef, adPromotionsRef, serverTimestamp } from '../firebase/collections';
import { ToastContext } from '../contextStore/ToastContext';

function PromoteAd() {
  const { t } = useTranslation();

  const PLANS = [
    { id: 'featured', label: t('admin.featured7Days'), days: 7 },
    { id: 'urgent', label: t('admin.urgentBadge7Days'), days: 7 },
    { id: 'top', label: t('admin.topAd14Days'), days: 14 },
  ];
  const { adId } = useParams();
  const { user } = useContext(AuthContext);
  const { addToast } = useContext(ToastContext);
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!adId || !user) return;
    getProductRef(adId)
      .get()
      .then((doc) => {
        if (doc.exists && doc.data().userId === user.uid) {
          setProduct({ id: doc.id, ...doc.data() });
        }
      })
      .finally(() => setLoading(false));
  }, [adId, user]);

  const handlePromote = (planId, days) => {
    if (!user || !adId) return;
    setSaving(true);
    const start = new Date();
    const end = new Date();
    end.setDate(end.getDate() + days);
    adPromotionsRef()
      .add({
        productId: adId,
        userId: user.uid,
        plan: planId,
        startDate: start.toISOString(),
        endDate: end.toISOString(),
        status: 'active',
        createdAt: serverTimestamp(),
      })
      .then(() => {
        addToast(t('admin.promotionStarted'), 'success');
      })
      .catch(() => addToast(t('admin.failedToPromote'), 'error'))
      .finally(() => setSaving(false));
  };

  if (!user) {
    return (
      <Layout>
        <p>{t('admin.pleaseLogIn')}</p>
      </Layout>
    );
  }
  if (loading) return <Layout><p>{t('admin.loading')}</p></Layout>;
  if (!product) {
    return (
      <Layout>
        <p>{t('admin.adNotFound')}</p>
        <Link to="/dashboard">{t('admin.backToDashboard')}</Link>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="promoteAdPage">
        <h1>{t('admin.promoteAd')}</h1>
        <p><strong>{product.name}</strong></p>
        <div className="promotePlans">
          {PLANS.map((plan) => (
            <div key={plan.id} className="promotePlanCard">
              <h3>{plan.label}</h3>
              <button
                type="button"
                onClick={() => handlePromote(plan.id, plan.days)}
                disabled={saving}
              >
                {saving ? t('admin.loading') : t('admin.promote')}
              </button>
            </div>
          ))}
        </div>
        <Link to={`/ad/${adId}`}>{t('admin.backToAd')}</Link>
      </div>
    </Layout>
  );
}

export default PromoteAd;
